import {useState} from "react";
import {Empty, Select} from "antd";
import {useGetTrendsHistoryQuery} from "~/reduxs/api/trendsApiSlice";
import TrendsTable from "./TrendsTable";

/**
 * Tab "Lịch sử": snapshot trending của các ngày trước (bảng trend_snapshots — hệ
 * thống tự lưu mỗi lần fetch tươi + tick hằng ngày). Chọn ngày → xem lại bảng
 * trending của ngày đó, vẫn lưu được từ khoá vào kho.
 */
function TrendsHistoryPanel({geo, onSave}) {

	// undefined = BE tự chọn ngày mới nhất có dữ liệu.
	const [date, setDate] = useState(undefined);

	const {data, isFetching} = useGetTrendsHistoryQuery({geo, date});

	const dates = data?.dates || [];
	const items = data?.items || [];

	if (!isFetching && dates.length === 0) {
		return <Empty description="Chưa có dữ liệu lịch sử — hệ thống lưu snapshot mỗi ngày kể từ hôm nay." />;
	}

	return (
		<div>
			<div style={{marginBottom: 12}}>
				<Select
					style={{minWidth: 180}}
					value={date || data?.date}
					loading={isFetching}
					onChange={(v) => setDate(v)}
					options={dates.map((d) => ({value: d, label: d}))}
					placeholder="Chọn ngày"
				/>
			</div>

			<TrendsTable items={items} loading={isFetching} showDays={false} onSave={onSave} />
		</div>
	);
}

export default TrendsHistoryPanel;
